<script>
    import { Doughnut } from 'vue-chartjs';
    
    export default {
        extends: Doughnut,
        props: {
            chartLabel: {
                type: Array
            },
            chartData: {
                type: Array
            },
            chartTotal: {
                type: [Number, String]
            },
            chartOptions: {
                type: Object,
                default: function() {
                    return {
                        legend: {
                            display: false
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    };
                }
            },
            chartColors: {
                type: Array,
                default: function() {
                    return ['#4273fa', '#60cf7d', '#fe3f61'];
                }
            }
        },
        
        data() {
            return {
                'dataset': {
                    data: this.chartData,
                    backgroundColor: this.chartColors
                },
                'options': this.chartOptions
            };
        },
        
        methods: {

        },
        
        mounted() {
            var textCenterValue = this.chartTotal;
            
            this.addPlugin({
                id: 'my-plugin',
                beforeDraw: function(chart) {
                    const width = chart.width;
                    const height = chart.height;
                    const fontSize = 15;

                    let ctx = chart.ctx;
                    ctx.restore();

                    ctx.font = fontSize + "px sans-serif";
                    ctx.textBaseline = "middle";

                    let textX = Math.round((width - ctx.measureText(textCenterValue).width) / 2);
                    let textY = Math.round(height / 2);

                    ctx.fillText(textCenterValue, textX, textY);
                    ctx.save();
                }
            }),

            this.renderChart({
                labels: this.chartLabel,
                datasets: [ this.dataset ]
            }, this.chartOptions);
            
        }
    };

</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/components/charts/DoughnutChart.vue